// import { useContext, useEffect } from "react";
// import { useToast } from "@chakra-ui/react";
// import { useDispatch } from "react-redux";
// import io from "socket.io-client";
// import { NotificationsContext } from "../../contexts/notificationContext";
// import { userNotiActiva } from "../../redux/actions/action.user";

const Alertas = () => {
  // const { setUpdate } = useContext(NotificationsContext);
  // const toast = useToast();
  // const dispatch = useDispatch();
  // const handleAlerta = (notification) => {
  //   setUpdate((prev) => !prev);
  //   toast({
  //     title: "¡Alerta!",
  //     description:
  //       notification && notification?.descripciónNBS
  //         ? notification?.descripciónNBS
  //         : "Revisa las notificaciones",
  //     status: "warning", // Puedes usar 'success', 'error', 'warning' o 'info'
  //     duration: 3000, // Duración en milisegundos
  //     isClosable: true, // Puede cerrarse haciendo clic en la 'X'
  //   });
  // };
  // useEffect(() => {
  //   socket.on("nuevoRegistroNotificaciones", (arg) => {
  //     console.log("nuevoRegistroNotificaciones", arg);
  //     handleAlerta(arg);
  //   });
  //   dispatch(userNotiActiva(true));
  //   // Limpiar el listener cuando el componente se desmonte
  //   return () => {
  //     socket.off("nuevoRegistroNotificaciones");
  //   };
  // }, []);
};

export default Alertas;
